import { useContext } from 'react';
import { DictionaryContext } from 'application/adapters/context/Dictionary';
import { M31ProductGrid } from 'ui/components/4-habitats/M31ProductGrid';
import { M31ProductGridCardProps } from 'ui/components/2-molecules/Card/M31ProductGridCard/M31ProductGridCard';

export const M31ProductGridFeature: React.FC<Umbraco.M31ProductGrid> = ({ content }) => {
	const dictionary = useContext(DictionaryContext);
	const { heading, gridItems } = content?.properties ?? {};

	const cardDictionary = {
		linkText: dictionary.getValue('M31ProductGrid.LinkText', null, 'Read more'),
	};

	// Map data for one Card
	const mappedGridItems = gridItems?.map((item) => {
		const sectionsOnPage = item?.Properties?.pageSections ?? [];
		const m28ProductOverview = sectionsOnPage.find((section) => section.documentType === 'm28ProductOverview');

		const m31ProductCard: M31ProductGridCardProps = {
			heading: m28ProductOverview?.content?.properties?.heading,
			facts: m28ProductOverview?.content?.properties?.facts.slice(0, 3), // max 3 facts
			description: m28ProductOverview?.content?.properties?.description,
			image: m28ProductOverview?.content?.properties?.carouselImages?.[0], // take 1st image
			url: item?.url,
			linkText: item?.Properties?.linkText ?? cardDictionary.linkText,
			linkAriaLabel: item?.Properties?.linkAriaLabel,
		};
		return m31ProductCard;
	});

	return <M31ProductGrid heading={heading} gridItems={mappedGridItems} />;
};
